<template>
  <div class="videoCont">
    <video ref="video" :src="src"  controls autoplay></video>
  </div>

</template>
<script>
import {getFile} from "../api";
import utils from "../lib/utils";

export default {
  name: "playVideo",
  data(){
    return{
      src:''
    }
  },
  methods:{

  },
  mounted() {
    const vid = this.$route.query.vid;   // 输出: 123
    let data={
      fileId:vid
    }
    console.log(data)
    getFile(data).then((res)=>{
      console.log(res)
      if(res.data.result.success){
        this.src=utils.handleHttps(res.data.result.cmsFile.uri)
        console.log(this.src)
      }else{
        this.$Message.error("获取视频失败")
      }
    })

  }
}
</script>


<style scoped lang="scss">
.videoCont{
  overflow-y: hidden;
  width: 100%;
  height: 100vh;
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: #000; /* 留白区域显示黑色背景 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/playVideo.vue